import { render, staticRenderFns } from "./EditCustomerRegisterModal.vue?vue&type=template&id=1d4b16c2&"
import script from "./EditCustomerRegisterModal.vue?vue&type=script&lang=ts&"
export * from "./EditCustomerRegisterModal.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports